import { IsString } from 'class-validator';

export class ContactInformationAddressInquiryDto {
  @IsString()
  postalCode!: string;
}
